import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import cn from 'classnames';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { hidePlayer, showLoading } from './utils';
import './QuestionPreviewContainer.scss';

const QuestionPreviewContainer = (props) => {
  const {
    children,
    containerRef,
    stopAudioFeatures,
    loadingIndicatorRef,
    cbPlayerRef,
    uuid,
  } = props;

  useEffect(() => {
    const container = containerRef.current;
    const onMouseLeave = (e) => {
      if (
        e.relatedTarget &&
        (e.relatedTarget === container || container.contains(e.relatedTarget))
      ) {
        return;
      }
      /**
       * If the mouse goes directly on the hovered element do not hide the container
       * */
      const reference = container.dataset.activequestion;
      const currentItemEl = container?.querySelector(
        `div[data-reference="${reference}---${uuid.getNameSpace()}"]`,
      );
      if (currentItemEl) {
        currentItemEl.style = null;
        currentItemEl.classList.add('is-invisible');
        currentItemEl.classList.remove('is-visible');
      }
      showLoading(container, loadingIndicatorRef.current, cbPlayerRef.current);
      hidePlayer(container);
      stopAudioFeatures(`${reference}---${uuid.getNameSpace()}`);
    };
    if (container) {
      container.addEventListener('mouseleave', onMouseLeave);
    }

    return () => {
      if (container) {
        container.removeEventListener('mouseleave', onMouseLeave);
      }
    };
  }, [containerRef.current]);

  useEffect(() => {
    let observer;
    if (containerRef.current) {
      observer = new MutationObserver((mutationsList) => {
        for (let i = 0; i <= mutationsList.length - 1; i++) {
          const mutationRecord = mutationsList[i];
          const { target } = mutationRecord;
          if (target.classList.contains('learnosity-feature')) {
            const audioFileElement = target.querySelector(
              'object.audio_file[data^="../asset"]',
            );
            if (audioFileElement) {
              audioFileElement.parentNode.removeChild(audioFileElement);
            }
          }
        }
      });

      observer.observe(containerRef.current, {
        subtree: true,
        childList: true,
      });
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [containerRef.current]);

  return createPortal(
    <div aria-live="polite" role="tooltip">
      <div
        data-activequestion=""
        ref={containerRef}
        className={cn(
          'PreviewItem qb_hover_preview_container flex bg-white z-max max-w-min min-w-200',
          'shadow-2xl rounded-lg border border-gray-500 absolute top-full -left-full invisible overflow-hidden',
        )}
      >
        <div className="loading-indicator absolute flex inset-0 items-center">
          <LoadingSpinner />
        </div>
        {children}
      </div>
    </div>,
    document.querySelector('#modal'),
  );
};

QuestionPreviewContainer.propTypes = {
  stopAudioFeatures: PropTypes.func,
};

QuestionPreviewContainer.defaultProps = {
  stopAudioFeatures: () => {},
};

export default withRouter(QuestionPreviewContainer);
